// ===== Sculptique landing page — light interactivity =====

/* ============================================================
   CHECKOUT CHAMP
   Fill these in from your Checkout Champ campaign, then replace
   the CC_* placeholders on each .pkg in index.html with the
   matching product IDs.
   ============================================================ */
window.CHECKOUT_CHAMP = {
  // Your CC funnel step URL, e.g. https://pay.yourdomain.com/ch1
  checkoutUrl: 'https://secure.trylymphelle.com/checkout',
  // Optional: tags the landing page inside CC reporting (cc_custom_<field>)
  customFields: { lp: 'lymphelle-lp1' },
};

// Delivery date chip — always 5 days out from today, so it never goes stale.
// Matches the authored format, e.g. "Wednesday, 10 August".
(function () {
  const chip = document.querySelector('.date-chip');
  if (!chip) return;
  const eta = new Date();
  eta.setDate(eta.getDate() + 5);
  if (chip.dataset.format === 'monthday') {
    const d = eta.getDate();
    const sfx = d % 10 === 1 && d !== 11 ? 'st' : d % 10 === 2 && d !== 12 ? 'nd' : d % 10 === 3 && d !== 13 ? 'rd' : 'th';
    chip.textContent = `${eta.toLocaleDateString('en-US', { month: 'long' })} ${d}${sfx}`;
    return;
  }
  chip.textContent = eta.toLocaleDateString('en-GB', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  });
})();

// Package picker: keep .selected class in sync with the checked radio
document.querySelectorAll('.pkg input[type="radio"]').forEach((radio) => {
  radio.addEventListener('change', () => {
    document.querySelectorAll('.pkg').forEach((opt) => opt.classList.remove('selected'));
    radio.closest('.pkg').classList.add('selected');
  });
  if (radio.checked) radio.closest('.pkg').classList.add('selected');
});
(function () {
  // Keep exactly one .selected, matching the restored radio
  const checked = document.querySelector('.pkg input[type="radio"]:checked');
  if (!checked) return;
  document.querySelectorAll('.pkg').forEach((opt) => opt.classList.remove('selected'));
  checked.closest('.pkg').classList.add('selected');
})();

// Automatic-refills toggle — swaps every option between subscription and
// one-time pricing (names, bottle counts, price, compare-at, savings) and
// switches the reassurance line under the payment icons.
(function () {
  const toggle = document.getElementById('subToggle');
  const panel = document.querySelector('.refill-toggle');
  const refillLine = document.querySelector('.refill-line');
  const onetimeLine = document.querySelector('.onetime-line');
  if (!toggle || !panel) return;

  // v2 buy box: price inside the Add To Cart button follows the selection.
  const syncCta = () => {
    const now = document.querySelector('.btn-cart .cta-now');
    const was = document.querySelector('.btn-cart .cta-was');
    const sel = document.querySelector('.pkg.selected');
    if (!now || !sel) return;
    const mode = toggle.checked ? 'sub' : 'otp';
    now.textContent = sel.dataset[mode + 'Now'];
    if (was) was.textContent = sel.dataset[mode + 'Was'];
  };

  const render = () => {
    const mode = toggle.checked ? 'sub' : 'otp';

    document.querySelectorAll('.pkg').forEach((pkg) => {
      const d = pkg.dataset;
      pkg.querySelector('.pkg-name').textContent = d[mode + 'Name'];
      const subEl = pkg.querySelector('.pkg-sub');
      subEl.innerHTML = subEl.dataset.format === 'save'
        ? `You save ${d[mode + 'Save']}`
        : `${d[mode + 'Qty']}&nbsp; |&nbsp; Save ${d[mode + 'Save']}`;
      pkg.querySelector('.pkg-price .now').textContent = d[mode + 'Now'];
      pkg.querySelector('.pkg-price .was').textContent = d[mode + 'Was'];
      const img = pkg.querySelector('.pkg-img');
      if (img && d[mode + 'Img']) img.src = d[mode + 'Img'];
    });

    panel.classList.toggle('off', !toggle.checked);
    if (refillLine) refillLine.hidden = !toggle.checked;
    if (onetimeLine) onetimeLine.hidden = toggle.checked;

    syncCta();
  };

  toggle.addEventListener('change', render);

  document.querySelectorAll('.pkg input[type="radio"]').forEach((r) =>
    r.addEventListener('change', syncCta)
  );

  render();
})();

// Hero gallery carousel — arrows + thumbnail strip (chrome is mobile-only via CSS)
(function () {
  const gallery = document.querySelector('.hero-gallery');
  const thumbs = document.querySelector('.gallery-thumbs');
  const prev = document.querySelector('.gal-arrow.prev');
  const next = document.querySelector('.gal-arrow.next');
  if (!gallery || !thumbs || !prev || !next) return;

  // Visual slides are the grandchildren, since .gallery-row uses display:contents
  const slides = [...gallery.querySelectorAll('.hero-main-wrap, .gallery-row > *')];
  if (!slides.length) return;

  const indexOfScroll = () =>
    gallery.clientWidth ? Math.round(gallery.scrollLeft / gallery.clientWidth) : 0;

  const goTo = (i) => {
    const target = Math.max(0, Math.min(slides.length - 1, i));
    gallery.scrollTo({ left: target * gallery.clientWidth, behavior: 'smooth' });
  };

  slides.forEach((slide, i) => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gal-thumb';
    btn.setAttribute('aria-label', `Show image ${i + 1} of ${slides.length}`);

    const img = slide.matches('img') ? slide : slide.querySelector('img');
    if (img) {
      const t = document.createElement('img');
      t.src = img.getAttribute('src').replace(/_1000x(?=\.(?:jpe?g|png|webp)(?:\?|$))/, '_240x');
      t.loading = 'lazy';
      t.decoding = 'async';
      t.alt = '';
      btn.appendChild(t);
    } else {
      // stat cards have no photo — show their percentage instead
      const pct = slide.querySelector('text');
      const label = document.createElement('span');
      label.textContent = pct ? pct.textContent : String(i + 1);
      btn.appendChild(label);
    }

    btn.addEventListener('click', () => goTo(i));
    thumbs.appendChild(btn);
  });

  const sync = () => {
    const i = indexOfScroll();
    [...thumbs.children].forEach((t, n) => t.classList.toggle('active', n === i));
    prev.disabled = i <= 0;
    next.disabled = i >= slides.length - 1;

    const active = thumbs.children[i];
    if (active) {
      const a = active.getBoundingClientRect();
      const c = thumbs.getBoundingClientRect();
      thumbs.scrollBy({ left: a.left + a.width / 2 - (c.left + c.width / 2), behavior: 'smooth' });
    }
  };

  prev.addEventListener('click', () => goTo(indexOfScroll() - 1));
  next.addEventListener('click', () => goTo(indexOfScroll() + 1));

  let ticking = false;
  gallery.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { sync(); ticking = false; });
  });

  sync();
})();

// Nutritional Information modal — only on pages that still have the pill.
// Guarded: an unguarded null here would stop every script below it,
// including the Checkout Champ handoff.
(function () {
  const nutriModal = document.getElementById('nutriModal');
  const nutriPill = document.querySelector('.nutri-pill');
  if (!nutriModal || !nutriPill) return;
  const openNutri = () => {
    nutriModal.hidden = false;
    document.body.classList.add('modal-open');
  };
  const closeNutri = () => {
    nutriModal.hidden = true;
    document.body.classList.remove('modal-open');
  };
  nutriPill.addEventListener('click', openNutri);
  nutriModal.querySelector('.nutri-close').addEventListener('click', closeNutri);
  nutriModal.addEventListener('click', (e) => {
    if (e.target === nutriModal) closeNutri();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !nutriModal.hidden) closeNutri();
  });
})();

// One-open-at-a-time accordion groups
const exclusiveGroups = ['.hero-accs .acc', '.faq-card .faq-item', '.ingredient-table .ing-cell'];
exclusiveGroups.forEach((selector) => {
  const items = document.querySelectorAll(selector);
  items.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        items.forEach((other) => {
          if (other !== item && other.open) other.open = false;
        });
      }
    });
  });
});

/* ============================================================
   ADD TO CART → Checkout Champ handoff
   Builds  <checkoutUrl>?products=<productId>:1;&...  using the
   product ID for whichever package + purchase mode is selected,
   and forwards the tracking params CC expects.
   ============================================================ */
(function () {
  const cart = document.querySelector('.btn-cart');
  const toggle = document.getElementById('subToggle');
  if (!cart) return;

  // Persist click IDs across the session so they survive the handoff
  const params = new URLSearchParams(location.search);
  ['clickid', 'affId', 'gclid', 'fbclid'].forEach((k) => {
    if (params.has(k)) sessionStorage.setItem('cc_' + k, params.get(k));
  });

  const buildUrl = () => {
    const pkg = document.querySelector('.pkg.selected');
    if (!pkg) return null;

    const subscribing = toggle ? toggle.checked : false;
    const productId = subscribing ? pkg.dataset.ccSub : pkg.dataset.ccOtp;
    // Variant tells CC which pack ships — without it the SKU can't resolve.
    const variantId = subscribing ? pkg.dataset.ccVarSub : pkg.dataset.ccVarOtp;
    if (!productId || productId.startsWith('CC_')) {
      console.warn('[Checkout Champ] No product ID set for this option yet.');
      return null;
    }

    const cfg = window.CHECKOUT_CHAMP;
    const url = new URL(cfg.checkoutUrl);
    // Line-item format: <productId>:<qty>;  (repeat, semicolon-separated)
    // Free gifts bundled with this tier (e-book / gift card) ride along as
    // extra line items — CC accepts semicolon-separated products.
    const gifts = (subscribing ? pkg.dataset.ccGiftsSub : pkg.dataset.ccGiftsOtp) || '';
    const giftPart = gifts
      .split(',')
      .filter(Boolean)
      .map((id) => `${id.trim()}:1;`)
      .join('');
    const main = variantId ? `${productId}.${variantId}:1;` : `${productId}:1;`;
    url.searchParams.set('products', main + giftPart);

    Object.entries(cfg.customFields || {}).forEach(([k, v]) =>
      url.searchParams.set(`cc_custom_${k}`, v)
    );

    // Carry attribution through to the order
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].forEach((k) => {
      if (params.has(k)) url.searchParams.set(k, params.get(k));
    });
    ['clickid', 'affId', 'gclid', 'fbclid'].forEach((k) => {
      const v = sessionStorage.getItem('cc_' + k);
      if (v) url.searchParams.set(k, v);
    });

    return url.toString();
  };

  cart.addEventListener('click', () => {
    const url = buildUrl();
    if (url) window.location.href = url;
  });
})();

/* ============================================================
   POLICY MODALS — footer links open accessible overlays.
   Close on X, Escape, or backdrop click. Locks body scroll,
   traps Tab focus inside the open modal, and returns focus to
   the link that opened it.
   ============================================================ */
(function () {
  const overlays = document.querySelectorAll('.policy-overlay');
  if (!overlays.length) return;

  const FOCUSABLE =
    'a[href], button:not([disabled]), input, textarea, select, [tabindex]:not([tabindex="-1"])';
  let lastFocused = null;

  const visibleFocusables = (overlay) =>
    [...overlay.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null);

  const open = (overlay, trigger) => {
    lastFocused = trigger || document.activeElement;
    overlay.hidden = false;
    document.body.classList.add('modal-open');
    overlay.querySelector('.policy-body').scrollTop = 0;
    const f = visibleFocusables(overlay);
    (f[0] || overlay).focus();
  };

  const close = (overlay) => {
    overlay.hidden = true;
    // Only release the scroll lock once no policy modal is still open
    if (!document.querySelector('.policy-overlay:not([hidden])')) {
      document.body.classList.remove('modal-open');
    }
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  };

  document.querySelectorAll('[data-modal]').forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const overlay = document.getElementById(link.dataset.modal);
      if (overlay) open(overlay, link);
    });
  });

  overlays.forEach((overlay) => {
    overlay.querySelector('.policy-close').addEventListener('click', () => close(overlay));
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) close(overlay);
    });
  });

  document.addEventListener('keydown', (e) => {
    const overlay = document.querySelector('.policy-overlay:not([hidden])');
    if (!overlay) return;

    if (e.key === 'Escape') {
      close(overlay);
      return;
    }
    if (e.key === 'Tab') {
      const f = visibleFocusables(overlay);
      if (!f.length) return;
      const first = f[0];
      const last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
